import MainMenu from './MainMenu';

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu/index.js